import {
    InputAdornment,
    TextField,
    Select,
    MenuItem,
    Typography
} from '@mui/material'
import { memo } from 'react'

import {
    defaultCountries,
    FlagEmoji,
    parseCountry,
    usePhoneInput
} from 'react-international-phone'

const MuiPhone = memo(
    ({
        value,
        onChange,
        onCountryChange,
        defaultCountry,
        selectedCountry,
        selectedCountries,
        label,
        ...restProps
    }) => {
        const countries = defaultCountries.filter((defaultCountryItem) =>
            selectedCountries
                ? selectedCountries.indexOf(defaultCountryItem[1]) != -1
                : true
        )

        const { phone, handlePhoneValueChange, country, inputRef, setCountry } =
            usePhoneInput({
                defaultCountry: selectedCountry?.toLocaleLowerCase(),
                value,
                countries,
                onChange: (data) => {
                    onChange(data.phone)
                }
            })

        return (
            <TextField
                variant="outlined"
                label={label ? label : null}
                placeholder="Phone number"
                color="primary"
                fullWidth
                value={phone}
                onChange={handlePhoneValueChange}
                type="tel"
                inputRef={inputRef}
                InputProps={{
                    startAdornment: (
                        <InputAdornment
                            position="start"
                            style={{ marginRight: '12px', marginLeft: '4px' }}
                        >
                            <Select
                                MenuProps={{
                                    style: {
                                        height: '300px',
                                        width: '360px',
                                        top: '10px',
                                        left: '-34px'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }
                                }}
                                sx={{
                                    width: 'max-content',
                                    // Remove default outline (display only on focus)
                                    fieldset: {
                                        display: 'none'
                                    },
                                    '&.Mui-focused:has(div[aria-expanded="false"])':
                                        {
                                            fieldset: {
                                                display: 'block'
                                            }
                                        },
                                    // Update default spacing
                                    '.MuiSelect-select': {
                                        padding: '8px',
                                        paddingRight: '24px !important'
                                    },
                                    svg: {
                                        right: 0
                                    }
                                }}
                                value={country}
                                onChange={(e) => {
                                    const newCountry = e.target.value

                                    setCountry(newCountry)

                                    const countryData = parseCountry(
                                        countries.find(
                                            (c) =>
                                                parseCountry(c).iso2 ===
                                                newCountry
                                        )
                                    )

                                    const newPhone = `+${countryData.dialCode}`

                                    onChange(newPhone)

                                    if (onCountryChange) {
                                        onCountryChange(newCountry)
                                    }
                                }}
                                renderValue={(value) => (
                                    <FlagEmoji
                                        iso2={value}
                                        style={{ display: 'flex' }}
                                    />
                                )}
                            >
                                {countries.map((c) => {
                                    const countryData = parseCountry(c)
                                    return (
                                        <MenuItem
                                            key={countryData.iso2}
                                            value={countryData.iso2}
                                        >
                                            <FlagEmoji
                                                iso2={countryData.iso2}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <Typography marginRight="8px">
                                                {countryData.name}
                                            </Typography>
                                            <Typography color="gray">
                                                +{countryData.dialCode}
                                            </Typography>
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </InputAdornment>
                    )
                }}
                {...restProps}
            />
        )
    }
)

export default MuiPhone
